import { render } from "./gcuLink.vue?vue&type=template&id=6f6a2895&scoped=true"
import script from "./gcuLink.vue?vue&type=script&lang=ts"
export * from "./gcuLink.vue?vue&type=script&lang=ts"

import "./gcuLink.vue?vue&type=style&index=0&id=6f6a2895&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f6a2895"

export default script